import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { authEndpoints } from '@/modules/auth/constants';

import { authQueryKeys } from './queryKeys';

type AuthTokenResponse = {
  accessToken: string;
};

export const useAuthTokenQuery = (
  options?: Omit<
    UseQueryOptions<AuthTokenResponse | undefined, Error>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: authQueryKeys.token(),
    queryFn: async () => {
      const { data } = await fetchClient.POST(authEndpoints.token);
      return data;
    },
    ...options,
  });
};
